export default __webpack_public_path__ + "static/media/ig-white.459a7de5.svg";